<template>
  <div>
    <div class="my_news">
      <div v-for="(item,index) in list" :key="index" style="border-bottom: 1px solid #e1e1e1">
        <p class="news">{{item.title}}</p>
        <div class="news_nav">
          <ul>
            <li v-for="(items,index) in item.data" :key="index">
              <router-link active-class="active" :to="items.url" exact>{{items.name}}</router-link>
               <p class="news_cont" v-if="items.url =='/expert_problem' ">
                 <span v-if="newCount >0">({{newCount}}未回复)</span>
               </p>
               <p class="news_cont" v-if="items.url =='/message'">
                <span v-if="unreCount >0">({{unreCount}}条未读)</span>
               </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {expertCount,unreadmsgcount} from "@/api/coment";
export default {
  data(){
    return{
      myList:[{
        title:'个人信息',
        data:[
          {
            name:'我的收入',
            url:'/income'
           },{
            name:'我的积分',
            url:'/integral'
           },{
            name:'我的需求',
            url:'/demand'
          },{
            name:'我的资料',
            url:'/means'
          },{
            name:'我的问题',
            url:'/problem'
          },{
            name:'我的购买',
            url:'/download'
          },{
            name:'我的收藏',
            url:'/collection'
         }]
        },{
        title:'环学院',
        data:[{
          name:'我的课程',
          url:'/curriculum'
        },{
          name:'我的活动',
          url:'/activity'
        }]
      },{
        title:'账号设置',
        data:[{
          name:'个人资料',
          url:'/personal_information'
        },{
          name:'修改密码',
          url:'/password_change'
        },{
          name:'会员权益',
          url:'/membership'
        },{
          name:'消息中心',
          url:'/message'
        }]
      }], //个人
      expertList:[{
        title:'专家信息',
        data:[
          {
            name:'我的收入',
            url:'/expert_income'
           },{
            name:'我的积分',
            url:'/integral'
           },{
            name:'我的需求',
            url:'/demand'
          },{
            name:'我的资料',
            url:'/means'
          },{
            name:'我的问题',
            url:'/expert_problem'
          },{
            name:'我的购买',
            url:'/download'
          },{
            name:'专家视角',
            url:'/expert_angle'
          },{
            name:'我的收藏',
            url:'/collection'
         }]
        },{
        title:'环学院',
        data:[{
          name:'我的课程',
          url:'/expert_curriculum'
        },{
          name:'我的活动',
          url:'/expert_activity'
        }]
      },{
        title:'账号设置',
        data:[{
          name:'账号信息',
          url:'/number'
        },{
          name:'修改密码',
          url:'/password_change'
        },{
          name:'会员权益',
          url:'/membership'
        },{
          name:'消息中心',
          url:'/message'
        }]
      }], //专家
      companyList:[{
        title:'企业信息',
        data:[
          {
            name:'企业收入',
            url:'/income'
           },{
            name:'企业积分',
            url:'/integral'
           },{
            name:'企业需求',
            url:'/demand'
          },{
            name:'企业资料',
            url:'/means'
          },{
            name:'企业问题',
            url:'/problem'
          },{
            name:'企业购买',
            url:'/download'
          },{
            name:'企业资讯',
            url:'/corporate_list'
          },{
            name:'经典案例',
            url:'/corporate_case'
         },{
            name:'供应信息',
            url:'/corporate_supply'
         },{
            name:'企业收藏',
            url:'/collection'
         }]
        },{
        title:'环学院',
        data:[{
          name:'企业课堂',
          url:'/curriculum'
        },{
          name:'企业活动',
          url:'/activity'
        },{
          name:'集采活动',
          url:'/jicai_activity'
        }]
      },{
        title:'账号设置',
        data:[{
          name:'生意助手',
          url:'/corporate_account'
        },{
          name:'企业介绍',
          url:'/corporate_news'
        },{
          name:'我的发票',
          url:'/corporate_invoice'
        }
        ,{
          name:'修改密码',
          url:'/password_change'
        },{
          name:'会员权益',
          url:'/membership'
        },{
          name:'企业认证',
          url:'/corporate_attestation'
        },{
          name:'消息中心',
          url:'/message'
        }]
      }],//企业
      list:[{
        title:"",
        data:[{
          name:'',
          url:''
        }]
        }],
      userType:"",
      newCount:'',
      unreCount:'',
      listQuery:{
        curPage:1,
        limit:100
      },

    }
  },
  created(){
   if(this.$store.state.user.userInfo != null){
     let type = this.$store.state.user.userInfo.type;
     switch(type){
      case 1:
	    this.list = this.myList;
        break;
      case 2:
        this.list = this.expertList;
        this.getExpertCount();
        break;
      case 3:
	    this.list = this.companyList;
		break;
      default:
        break;
    }
   }
   this.getExpertCount();
   this.getUnreadmsgcount();
  },
  computed:{
    newsCount(){
      return this.$store.getters.newCount
    }
  },
  methods:{
    //查询专家未回复数量
    getExpertCount(){
      expertCount().then((res)=>{
        if(res.code == 0){
           this.newCount = res.data;
        }
      }).catch((err)=>{})
    },
    //查询站内未读消息
    getUnreadmsgcount(){
      unreadmsgcount().then((res)=>{
        if(res.code == 0){
          this.unreCount = res.data;
        }
      }).catch((err)=>{})
    }
  }
};
</script>
<style scoped>
.news {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  padding: 18px 0px;
  border-bottom: 1px dashed #e1e1e1;
  margin: 0px 20px;
}
.news_nav li{
  position: relative;
}
.news_nav li a {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
  display: inline-block;
  padding: 13px 0px;
  width: 100%;
}
.news_nav li:hover {
  background: #e6e6e6;
}
.active {
  background: #e6e6e6;
  position: relative;
}
.news_cont{
  position: absolute;
  top:14px;
  right:21%;
  font-size: 12px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/common/sidebar.vue